<section class="user-action-stats">
  <header class="user-action-stats__header">
    <h2 class="user-action-stats__title">
      {{ "user-action-stats-widgets.title.user-activity" | translate }}
    </h2>

    <div class="user-action-stats__controls">
      <sui-button
        size="sm"
        variant="secondary"
        [leadingIcon]="['fas', 'rotate']"
        [disabled]="loading()"
        (click)="refresh()"
        >{{
          "user-action-stats-widgets.button.refresh" | translate
        }}</sui-button
      >
    </div>
  </header>

  <div class="user-action-stats__grid">
    @for (view of views(); track view.key) {
      <div
        class="data-widget"
        [class.user-action-stats__widget--full]="view.fullWidth"
        [class.data-widget--refreshing]="view.refreshing"
        [attr.aria-busy]="view.refreshing || null"
      >
        <div class="data-widget__header">
          <span class="data-widget__title">
            {{ view.titleKey | translate }}
            <span class="data-widget__subtitle"
              >({{ periodLabel() }}
              @if (view.timeSeries) {
                , {{ bucketLabel() }}
              }
              )</span
            >
          </span>
        </div>

        @if (view.options; as options) {
          <highcharts-chart
            class="data-widget__chart"
            [Highcharts]="Highcharts"
            [options]="options"
            [oneToOne]="true"
          ></highcharts-chart>
        } @else if (view.empty) {
          <div class="user-action-stats__empty">
            {{ view.emptyKey | translate }}
          </div>
        } @else if (view.pending) {
          <app-loading-card type="data-widget" [count]="1"></app-loading-card>
        } @else if (view.failed) {
          <div class="data-widget__empty">
            {{ "user-action-stats-widgets.error.load-failed" | translate }}
          </div>
        }
      </div>
    }
  </div>
</section>
